import { render, staticRenderFns } from "./PriceSelectors.vue?vue&type=template&id=dcd3f778&scoped=true&"
import script from "./PriceSelectors.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceSelectors.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PriceSelectors.vue?vue&type=style&index=0&id=dcd3f778&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd3f778",
  null
  
)

export default component.exports